import apiUrl from '../../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Paginate from 'vuejs-paginate'
import PageTracker from '../../../../common/PageTrackerHelper'
import moment from 'moment';
import Papa from "papaparse";
// import CProgress from '@coreui/vue/src/components/progress/CProgress'
// import { getLoggedInUserInfo as getUserInfo } from '../../../../libs/UserSessionInfo.js'


export default {
  name: 'HR/Finance Recovery upload',
  components: {
      VueElementLoading,
      Paginate,
      // CProgressBar
  },
  mixins:[PageTracker],
  data: function() {
      return {
        file: '',
        filename: '',
        recoveryfile: '',
        recoveryfilename: '',
        filedata: [],
        recoveryFiledata: [],
        PromiseChainResult: [],
        PromiseChainResult1: [],
        isLoading: false,
        isLoading1: false,
        isDownloadFlag: false,
        UpdateApprovalKey: [],
        UpdateApprovalKey1: [],
        approvalfor: 0,
        approvalfor1: 0,
        uploadResult: [],
        recoveryuploadResult: [],
        errorList: [],
        errorList1: [],
        batchkeyArray: [],
        batchkeyArray1: [],
        UploadConfigDetails: {},
        uploadLimit : 0,
        userDataKey : '',
        isShow:true,
        isShow1:true,
        localusermailid:'',
      }
  },
  created: function() {
  },
async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    // console.log('test -->>', currentDate.format('M'););
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    // let TrackerInfo = {
    //     projectname:"Lastmile-web",
    //     type:"Web",
    //     userid:this.localuserid,
    //     username:this.localusermailid,
    //     meta: {
    //         "event":""
    //     }
    // }
    // let result  = this.PageTracker(TrackerInfo);
    let getconfig = await this.getconfigFlags()
    this.UploadConfigDetails = JSON.parse(getconfig);
    this.uploadLimit = this.UploadConfigDetails ? this.UploadConfigDetails.pageCuttoff : 0
    console.log('this.UploadConfigDetails ----->>', this.UploadConfigDetails);
    //console.log('Mixin is working for :',result);
  },
  methods : {
    generateUploadId(userId) {
      return `XB_${userId}_${Date.now()}_${String(Math.floor(Math.random() * 1e6)).padStart(6, '0')}`;
    },
    // async chooseFile(e){
    //    try {
    //    const files = e.target.files;
    //    this.filename = e.target.files[0].name;
    //    this.file = e.target.files[0];
    //    // console.log('file names ', this.file);
    //    await this.parseFile();
    //    // console.log('this.filedata --->>>', this.filedata.data);
    //    } catch(err){
    //      console.log(err);
    //    }
    // },
    // async parseFile(){
    //    var count = 0; // cache the running count
    //    var csvData=[];
    //    var sheetid = 1;
    //    var validheader = 1;
    //    var sheetApproveKey = 'appoveDataKey1'
    //    var holdErrors = []
    //    var vm = this
    //    Papa.parse( this.file, {
    //        header: true,
    //        skipEmptyLines: true,
    //        before: this.isLoading = true,
    //        worker: true, // Don't bog down the main thread if its a big file
    //        step: async function(result) {
    //          // console.log("result -------->>>>", result);
    //          let fileHeaders = result.meta.fields;
    //          // let fileHeaders = result.meta.fields.map(word => word.toLowerCase());
    //          // console.log('fileHeaders ---------->', fileHeaders);
    //          if(sheetid==1 && !fileHeaders.includes("SHIPPINGID") ||
    //            !fileHeaders.includes(("DEBITFROMTYPE")) ||
    //            !fileHeaders.includes("DEBITID")){
    //              this.filedata = [];
    //              this.filename=null;
    //              validheader = 0;
    //          }
    //          sheetid ++;
    //          let tempResult = {};
    //            tempResult.shippingid = (result.data['SHIPPINGID'])?result.data['SHIPPINGID']:null;
    //            tempResult.debitfromtype = (result.data['DEBITFROMTYPE'])?result.data['DEBITFROMTYPE']:null;
    //            tempResult.userid = (result.data['DEBITID'])?result.data['DEBITID']:null;
    //            // tempResult.debitamount = (result.data['debitamount'])?result.data['debitamount']:null;
    //            // tempResult.remainingamount = (result.data['remainingamount'])?result.data['remainingamount']:null;
    //            // tempResult.status = (result.data['status'])?result.data['status']:null;
    //            // tempResult.ispartialdebit = (result.data['ispartialdebit'])?result.data['ispartialdebit']:null;
    //            // tempResult.comments = (result.data['comments'])?result.data['comments']:null;
    //            // tempResult.CreatedBy = 'schedular'
    //            // tempResult.approvalkey = sheetApproveKey
    //
    //            // let shippingIDvalidation = await vm.validteShippingID(holdErrors,tempResult,sheetid)
    //            // let debitFromTypeValidation = await vm.validteDebitFromType(holdErrors,tempResult,sheetid)
    //            // let debituservalidation = await vm.validteUserid(holdErrors,tempResult,sheetid)
    //            // let debitamountvalidation = vm.validteDebitAmount(holdErrors,tempResult,sheetid)
    //            // let remainingAmountValidation = await vm.validteRemainingAmount(holdErrors,tempResult,sheetid)
    //            // let ispartialValidation = await vm.validteIspartial(holdErrors,tempResult,sheetid)
    //            // console.log('debitamountvalidation --->>', debitamountvalidation);
    //
    //            //csv row validations.
    //            if(tempResult.shippingid == null) {
    //              holdErrors.push({'lineNumber': sheetid, 'message': 'Shipping id should not be empty.!'})
    //            }
    //
    //            if(tempResult.debitfromtype == null ) {
    //              holdErrors.push({'lineNumber': sheetid, 'message': 'DebitFromType column should not be empty.!'})
    //            }
    //            if(tempResult.userid == null) {
    //              holdErrors.push({'lineNumber': sheetid, 'message': 'Debit user id column should not be empty.!'})
    //            }
    //
    //            let numberRegex = /^[0-9]+$/;
    //            let alphaNUmeric = /^[a-z0-9]+$/i;
    //
    //            if(tempResult.shippingid != null && alphaNUmeric.test(tempResult.shippingid) == false) {
    //              holdErrors.push({'lineNumber': sheetid, 'message': 'Invalid shippingid, Please provide valid shipping id and it must be alphanumeric.!'})
    //            }
    //            if(tempResult.userid != null && numberRegex.test(tempResult.userid) == false) {
    //              holdErrors.push({'lineNumber': sheetid, 'message': 'Debit user id must be be number.!'})
    //            }
    //            if(tempResult.debitfromtype != null && !['servicecenter','coloader','courier','networkvendor','vendor'].includes(tempResult.debitfromtype.toLowerCase().trim())) {
    //              holdErrors.push({'lineNumber': sheetid, 'message': 'Invalid debit from type, Please provide valid debitfromtype.!'});
    //            }
    //            // console.log('tempResult.debitid ---->>', tempResult.userid);
    //
    //            // let numberDebitRegex = /^\d*\.?\d*$/;
    //            // // if(tempResult.debitamount == null) {
    //            // //   holdErrors.push({'lineNumber': sheetid, 'message': 'Debit amount  not be empty.!'})
    //            // // }
    //            // // if(tempResult.debitamount == 0) {
    //            // //   holdErrors.push({'lineNumber': sheetid, 'message': 'Debit amount must be greater than zero.!'})
    //            // // }
    //            // if(numberDebitRegex.test(parseFloat(tempResult.debitid)) == false) {
    //            //   holdErrors.push({'lineNumber': sheetid, 'message': 'Debit user id should be number.!'})
    //            // }
    //            // //
    //            // // if(tempResult.remainingamount == null) {
    //            // //   holdErrors.push({'lineNumber': sheetid, 'message': 'Remaining amount should not be empty.!'})
    //            // // }
    //            // // if(numberDebitRegex.test(parseFloat(tempResult.remainingamount)) == false) {
    //            // //   holdErrors.push({'lineNumber': sheetid, 'message': 'Remaining amount should be number.!'})
    //            // // }
    //            //
    //            // if(tempResult.ispartialdebit == null) {
    //            //   pushErrors.push({'lineNumber': sheetid, 'message': 'Partial debit column should not be empty.!'})
    //            // }
    //            // if(!['0','1'].includes(tempResult.ispartialdebit)) {
    //            //   holdErrors.push({'lineNumber': sheetid, 'message': 'Partial column allows only input as 0 or 1.!'})
    //            // }
    //
    //            if(tempResult.shippingid != null && tempResult.userid != null && tempResult.debitfromtype != null) {
    //               // console.log('success');
    //               csvData.push(tempResult);
    //            }
    //            // console.log("csvData ----------->>", csvData);
    //            // console.log('ispartialValidation ---->>', ispartialValidation);
    //            // if(tempResult.shippingid != null && tempResult.debitfromtype != null && tempResult.userid != null && tempResult.debitamount != null && tempResult.remainingamount != null && tempResult.ispartialdebit != null ) {
    //            //   // console.log('tempResult --->>', tempResult);
    //            //    csvData.push(tempResult);
    //            // }
    //        },
    //        complete: function(){
    //          // console.log('holdErrorsTest ==>>', holdErrors.length);
    //          // console.log('csvData.length ==>>', csvData.length);
    //          // console.log('this.UploadConfigDetails123 --->>', this.UploadConfigDetails.pageCuttoff);
    //          let pagelimit = this.UploadConfigDetails.pageCuttoff && this.UploadConfigDetails.pageCuttoff != '' ? this.UploadConfigDetails.pageCuttoff : '100'
    //          let Batchlimit = this.UploadConfigDetails.batchCuttoff && this.UploadConfigDetails.batchCuttoff != '' ? this.UploadConfigDetails.batchCuttoff : '5000'
    //          // console.log('pagelimit ----->', pagelimit);
    //          // console.log('Batchlimit ----->', Batchlimit);
    //          // console.log('validheader ----->', validheader);
    //          if(validheader == 0){
    //            this.isLoading = false;
    //            this.filedata = [];
    //            this.filename = null;
    //            this.file = ''
    //            return this.$alertify.error('header mismatch issue, Please make ensure header should be in uppercase.!', "", "error");
    //
    //          } else if(holdErrors.length > 0){
    //            this.errorList = holdErrors
    //            this.isLoading = false;
    //            this.filedata = [];
    //            this.filename = null;
    //            this.file = ''
    //            return this.$alertify.error('Invalid data in the file.', "", "error");
    //
    //          } else if(csvData.length<1){
    //            this.isLoading = false;
    //            this.filedata = [];
    //            this.filename = null;
    //            this.file = ''
    //            return this.$alertify.error('Uploaded file is blank. At least one record set is required.', "", "error");
    //          } else if (csvData.length > pagelimit) {
    //            this.errorList = holdErrors
    //            this.isLoading = false;
    //            this.filedata = [];
    //            this.filename = null;
    //            this.file = ''
    //            return this.$alertify.error(`Allowed only ${pagelimit} shipments in one go, please upload file accordingly.`, "", "error");
    //          }
    //          else{
    //            this.filedata = csvData;
    //            this.totalrecords = csvData.length;
    //            this.chunkArray(this.filedata, Batchlimit); //pass batch cuttoff
    //          }
    //        }.bind(this)
    //    });
    //  },
     // async chunkArray(myArray, chunk_size){
     //       try {
     //       console.log("Start Time", Date() );
     //
     //       var index = 0;
     //       var arrayLength = myArray.length;
     //       let tempArr = [];
     //       let promiseArray = []
     //       this.UpdateApprovalKey = [];
     //       this.PromiseChainResult = [];
     //
     //       let chain = Promise.resolve();
     //       let self = this
     //
     //       for(index = 0; index < arrayLength; index += chunk_size) {
     //         let myChunk = myArray.slice(index, index+chunk_size);
     //         // console.log('myChunk ----->>>>', myChunk);
     //         chain = chain.then(() => self.uploadHRApproval(myChunk, index));
     //       }
     //       chain.then((result) => {
     //         // console.log('Result  Test---->>', result);
     //         if(result) {
     //           let tempTotalCount = 0;
     //           let tempUploadedTotalCount = 0;
     //           this.PromiseChainResult.forEach((value,idx) => {
     //             tempTotalCount = parseFloat(tempTotalCount) + parseFloat(value.TotalCount)
     //             tempUploadedTotalCount = parseFloat(tempUploadedTotalCount) + parseFloat(value.insertedCount)
     //           })
     //           this.uploadResult = [];
     //           this.uploadResult.push({"totalCount": tempTotalCount, "uploadeCount": tempUploadedTotalCount});
     //           // this.$alertify.success("File data loaded Successfully");
     //           let reqObjectProcess = {
     //             batchkey: this.UpdateApprovalKey,
     //             statusfor: this.approvalfor,
     //             lastmodifiedby: this.localusermailid
     //           }
     //           console.log("End Time", Date());
     //           this.triggerPopUpDialogForConfirmation(this.uploadResult, reqObjectProcess)
     //         } else {
     //            this.isLoading = false;
     //            return false;
     //          }
     //          this.isLoading = false;
     //       })
     //       .catch((err) => {
     //         console.log('chain error', err);
     //       })
     //     }catch (err){
     //       console.log(err);
     //     }
     //  },
      // async triggerPopUpDialogForConfirmation(getResult, reqObjectProcess) {
      //
      //   let htmltablecontent = '<table border="2" cellpadding="10" cellspacing="0"> <th>Total Count</th> <th>Uploaded Count</th>';
      //   let resultcount = getResult.length
      //   for(let j=0; j< resultcount; j++) {
      //
      //     htmltablecontent +=`
      //       <tr>
      //         <td> ${getResult[j].totalCount} </td>
      //         <td> ${getResult[j].uploadeCount } </td>
      //       </tr>`
      //   }
      //   htmltablecontent += `</table>`;
      //   // console.log('htmltablecontent --->>', htmltablecontent);
      //   let message = {
      //       title: 'Alert',
      //       body: `<p>Uploaded summary.! <br/> Do you want to proceed for update approval? </p><br/>
      //       ${htmltablecontent}
      //       <br>
      //       `,
      //     };
      //
      //     let res = await this.$dialog.confirm(message, {
      //       html: true,
      //       animation: 'bounce',
      //       backdropClose: false,
      //       okText: 'Yes',
      //       cancelText: 'No',
      //       reverse: true
      //     })
      //     .then(dialog => {
      //       console.log('success', reqObjectProcess);
      //       this.$alertify.success("File uploaded successfully, output summary will be sent over email.");
      //       this.processDumpData(reqObjectProcess)
      //     })
      //     .catch((e) => {
      //       //add logic for delete mechanism.
      //       console.log('popup catch',e);
      //     })
      // },
      processDumpData(reqObjectProcess) {

        axios({
          method: 'POST',
          url: apiUrl.api_url + 'lostshipmentinfo/approval/processuploaded/dump',
          data: reqObjectProcess
        }).then(async approveHRresult => {
          console.log('approveHRresult -->>', approveHRresult);
          this.clear()
        }, error => {
          this.ConfirmLoader = false
        });
      },
     //  uploadHRApproval(myChunk, index) {
     //   return new Promise((resolve, reject) => {
     //     try {
     //       let batchId =`F${(Math.random() + 1).toString(36).substring(9)}`;
     //      //  console.log("random", batchId);
     //       let newChunkArray = myChunk.map(chunk => Object.assign(chunk, {approvalkey: batchId}))
     //       this.UpdateApprovalKey.push(batchId)
     //       let approveObj = {
     //         approvalShipments: newChunkArray,
     //         approvalKey: batchId,
     //         approvalFor: this.approvalfor,
     //         CreatedBy: this.localusermailid
     //       }
     //       axios({
     //         method: 'POST',
     //         url: apiUrl.api_url + 'lostshipmentinfo/approval/upload/dump',
     //         data: approveObj
     //       }).then(async approveHRresult => {
     //         // console.log('approveHRresult -->>', approveHRresult);
     //         this.batchkeyArray.push(batchId)
     //         if (approveHRresult.data.code == 200) {
     //           this.PromiseChainResult.push(approveHRresult.data.data)
     //           resolve(true)
     //         }else if (approveHRresult.data.code == 202){
     //           this.$alertify.error('Invalid data in csv file, '+ approveHRresult.data.message);
     //           resolve(false)
     //         } else {
     //           this.$alertify.error(approveHRresult.data.message);
     //           resolve(true)
     //         }
     //
     //       }, error => {
     //         resolve(false)
     //         console.error(1,error)
     //         this.ConfirmLoader = false
     //       });
     //     } catch(e) {
     //       resolve(e)
     //     }
     //   })
     // },
      // validteShippingID(pushErrors, obj,sheetid){
      //   return new Promise((resolve, reject) => {
      //     try {
      //       if(obj.shippingid == null) {
      //         pushErrors.push({'lineNumber': sheetid, 'message': 'Shipping id should not be empty.!'})
      //         resolve(pushErrors)
      //       } else {
      //         resolve(pushErrors)
      //       }
      //     } catch(e){
      //       console.log('catch errror --->>', e);
      //     }
      //   })
      // },
      // validteDebitFromType(pushErrors, obj,sheetid){
      //   return new Promise((resolve, reject) => {
      //     if(obj.debitfromtype == null) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit from type column should not be empty.!'})
      //       resolve(false)
      //     } else {
      //       resolve(true)
      //     }
      //   })
      // },
      validteUserid(pushErrors, obj,sheetid){

        return new Promise((resolve, reject) => {
          let numberRegex = /^[0-9]+$/;

          if(obj.userid == null) {
            pushErrors.push({'lineNumber': sheetid, 'message': 'Debit User column should not be empty.!'})
            resolve(false)
          } else if(numberRegex.test(parseFloat(parseFloat(obj.userid))) == false) {
            pushErrors.push({'lineNumber': sheetid, 'message': 'Debit user id must be be number.!'})
            resolve(false)
          } else {
            resolve(true)
          }
        })
      },
      // validteDebitAmount(pushErrors, obj,sheetid) {
      //   // return new Promise((resolve, reject) => {
      //     let numberDebitRegex = /^\d*\.?\d*$/;
      //     if(obj.debitamount == null) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit amount should not be empty.!'})
      //       // resolve(false)
      //       return false
      //     } else if(obj.debitamount == 0) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit amount should be greater than zero.!'})
      //       // resolve(false)
      //     } else if(numberRegex.test(parseFloat(obj.debitamount)) == false) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit amount should be number.!'})
      //       // resolve(false)
      //       return false
      //     } else {
      //       return true
      //       // resolve(true)
      //     }
      //   // })
      // },
      // validteRemainingAmount(pushErrors, obj,sheetid) {
      //   return new Promise((resolve, reject) => {
      //     let numberRegex = /^\d*\.?\d*$/;
      //     if(obj.remainingamount == null) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit amount should not be empty.!'})
      //       resolve(false)
      //     } else if(numberRegex.test(parseFloat(obj.remainingamount)) == false) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Debit amount should be number.!'})
      //       resolve(false)
      //     } else {
      //       resolve(true)
      //     }
      //   })
      // },
      // validteIspartial(pushErrors, obj,sheetid) {
      //   return new Promise((resolve, reject) => {
      //     if(obj.ispartialdebit == null) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Partial debit column should not be empty.!'})
      //       resolve(false)
      //     } else if (!['0','1'].includes(obj.ispartialdebit)) {
      //       pushErrors.push({'lineNumber': sheetid, 'message': 'Partial column allows only input as 0 or 1.!'})
      //       resolve(false)
      //     } else {
      //       resolve(true)
      //     }
      //   })
      // },

      //LostRecovery--------------------------------
      async chooseFile1(e){
        try {
        const files = e.target.files;
        this.recoveryfilename = e.target.files[0].name;
        this.recoveryfile = e.target.files[0];
        // await this.parseFile1();
        } catch(err){
          console.log(err);
        }
     },
     normalizeHeader(header) {
       return typeof header === 'string'
        ? header.trim().toUpperCase()
        : '';
    },
    normalizeKeysInPlace(obj) {
      Object.keys(obj).forEach(key => {
        if (typeof key !== 'string') return;

        const normalizedKey = key.trim().toUpperCase();

        if (normalizedKey !== key) {
          obj[normalizedKey] = obj[key];
          delete obj[key];
        }
      });
    },
     async parseFile1(){
        var count = 0; // cache the running count
        var csvData=[];
        var sheetid = 1;
        var validheader = 1;
        var sheetApproveKey = 'appoveDataKey1'
        var holdErrors = [];
        var approvalFor1= this.approvalfor1;
        console.log("approvalFor1 ========>>", approvalFor1);
        var vm = this
          Papa.parse( this.recoveryfile, {
            header: true,
            skipEmptyLines: true,
            before: this.isLoading1 = true,
            worker: true, // Don't bog down the main thread if its a big file
            step: async function(result) {
              // let fileHeaders = result.meta.fields;
              vm.normalizeKeysInPlace(result.data);
              let fileHeaders = result.meta.fields.map(vm.normalizeHeader);

              if(sheetid==1 &&
                // !fileHeaders.includes(("DEBITFROMTYPE")) ||
                (['hrclosedebit', 'financeclosed'].includes(approvalFor1) && !fileHeaders.includes("EMPLOYEECODE")) ||
                !fileHeaders.includes("RECOVEREDAMT") ||
                // !fileHeaders.includes("TOTALDUEAMT") ||
                (approvalFor1=="financeclosed" && !fileHeaders.includes('LEDGERID'))||
                ((approvalFor1=="hrclosedebit" || approvalFor1=="financerecovery") && !fileHeaders.includes('DEBITSTATUS')) ||
                (approvalFor1=="financerecovery" && !fileHeaders.includes("DEBITFROMTYPE") &&  !fileHeaders.includes("XBPARTNERID")) ||
                (approvalFor1=="financerecovery" && (!fileHeaders.includes('DEBITNOTEID') || !fileHeaders.includes('DEBITNOTEDATE') || !fileHeaders.includes('RECOVERYLEDGERNAME')))

              ){
                  this.recoveryFiledata = [];
                  this.recoveryfilename=null;
                  validheader = 0;
              }


              sheetid ++;
              let tempResult = {};
                tempResult.debitfromtype = (result.data['DEBITFROMTYPE'])?result.data['DEBITFROMTYPE']: (approvalFor1=="hrclosedebit" || approvalFor1=="financeclosed") ? 'servicecenter' : null;
                console.log("tempResult ===============>>", tempResult);

                // tempResult.employeecode = (result.data['EMPLOYEECODE'])?result.data['EMPLOYEECODE']:null;
                let labelTextForDebitid = ( approvalFor1=="hrclosedebit" || approvalFor1=="financeclosed" ) ? 'EMPLOYEECODE' : 'XBPARTNERID';

                if ((approvalFor1=="hrclosedebit" || approvalFor1=="financeclosed")) {
                  // tempResult.debitid = (result.data['EMPLOYEECODE'])? result.data['EMPLOYEECODE'].toString().trim(): null;
                  tempResult.debitid = result.data['EMPLOYEECODE'] && String(result.data['EMPLOYEECODE']).trim()  ? String(result.data['EMPLOYEECODE']).trim() : null;
                } else if (approvalFor1=="financerecovery") {
                  tempResult.debitid = result.data['XBPARTNERID'] && String(result.data['XBPARTNERID']).trim()  ? String(result.data['XBPARTNERID']).trim() : null;
                } else {
                  tempResult.debitid = null;
                }


                tempResult.comments= (result.data['REMARKS'])?result.data['REMARKS']:null;

                tempResult.recoveredamt= (result.data['RECOVEREDAMT'])?result.data['RECOVEREDAMT']:null;
                // tempResult.debitamount= (result.data['TOTALDUEAMT'])?result.data['TOTALDUEAMT']:null;
                if(approvalFor1=="hrclosedebit" || approvalFor1=="financerecovery"){
                  tempResult.debitstatus= (result.data['DEBITSTATUS'])?result.data['DEBITSTATUS']:null;
                }
                if(approvalFor1=="financerecovery"){
                  tempResult.debitnoteid= (result.data['DEBITNOTEID'])?result.data['DEBITNOTEID']:null;
                  tempResult.debitnotedate= (result.data['DEBITNOTEDATE'])?result.data['DEBITNOTEDATE']:null;
                  tempResult.recoveryledgername= (result.data['RECOVERYLEDGERNAME'])?result.data['RECOVERYLEDGERNAME']:null;
                }
                if(approvalFor1=="financeclosed"){
                  tempResult.ledgerid= (result.data['LEDGERID'])?result.data['LEDGERID']:null;
                }

                if(tempResult.debitfromtype == null ) {
                  holdErrors.push({'lineNumber': sheetid, 'message': 'DebitFromType column should not be empty.!'})
                }
                if((approvalFor1=="hrclosedebit" || approvalFor1=="financeclosed") &&  tempResult.debitfromtype.toLowerCase().trim()!="servicecenter"){
                  holdErrors.push({'lineNumber': sheetid, 'message': 'SerivceCenter DebitFromType allowed only.!'})
                }else
                if(approvalFor1=="financerecovery" &&  tempResult.debitfromtype.toLowerCase().trim()=="servicecenter"){
                  holdErrors.push({'lineNumber': sheetid, 'message': 'SerivceCenter DebitFromType not allowed.!'})
                }
                if(tempResult.debitid == null) {
                  holdErrors.push({'lineNumber': sheetid, 'message': (approvalFor1=="hrclosedebit" || approvalFor1=="financeclosed") ? 'EMPLOYEECODE column should not be empty.!' : 'XBPARTNERID column should not be empty.!'})
                }
                if(approvalFor1=="financeclosed" && tempResult.ledgerid == null) {
                  holdErrors.push({'lineNumber': sheetid, 'message': 'LEDGERID column should not be empty.!'})
                }else if((approvalFor1=="hrclosedebit" || approvalFor1=="financerecovery") && tempResult.ledgerid != null){
                  holdErrors.push({'lineNumber': sheetid, 'message': 'LEDGERID not allowed..!!!'})
                }
                if((approvalFor1=="hrclosedebit" || approvalFor1=="financerecovery") && tempResult.debitstatus== null){
                  holdErrors.push({'lineNumber': sheetid, 'message': 'DEBITSTATUS column should not be empty.!'})
                }else if(approvalFor1=="financeclosed" && tempResult.debitstatus != null) {
                  holdErrors.push({'lineNumber': sheetid, 'message': 'DEBITSTATUS not allowed..!!!'})
                }

                if(approvalFor1=="financerecovery" && tempResult.debitnoteid== null && tempResult.debitnoteid!= null){
                  holdErrors.push({'lineNumber': sheetid, 'message': 'DEBITNOTEID column should not be empty.!'})
                }
                if(approvalFor1=="financerecovery" && tempResult.debitnotedate== null && tempResult.debitnotei!= null){
                  holdErrors.push({'lineNumber': sheetid, 'message': 'DEBITNOTEDATE column should not be empty.!'})
                }
                if(approvalFor1=="financerecovery" && tempResult.recoveryledgername== null){
                  holdErrors.push({'lineNumber': sheetid, 'message': 'RECOVERYLEDGERNAME column should not be empty.!'})
                }

                if(tempResult.recoveredamt == null) {
                  holdErrors.push({'lineNumber': sheetid, 'message': 'RECOVEREDAMT column should not be empty.!'})
                }
                // if(tempResult.debitamount == null) {
                //   holdErrors.push({'lineNumber': sheetid, 'message': 'TOTALDUEAMT column should not be empty.!'})
                // }
                // if(tempResult.status == null) {
                //   holdErrors.push({'lineNumber': sheetid, 'message': 'status column should not be empty.!'})
                // }
                let numberRegex = /^[0-9]+$/;
                let alphaNUmeric = /^[a-z0-9_/-]+$/i;
                let floatNumber =/^([0-9]*[.])?[0-9]+$/


                if(tempResult.debitid != null && alphaNUmeric.test(tempResult.debitid) == false) {
                  holdErrors.push({'lineNumber': sheetid, 'message': `${labelTextForDebitid} must be alpha numeric.!`})
                }

                const found = csvData.some(el => el.debitid === tempResult.debitid);
                if(found){
                  holdErrors.push({'lineNumber': sheetid, 'message': `Duplicate ${labelTextForDebitid} not allowed .!`})
                }
                if(approvalFor1=="financeclosed" && tempResult.ledgerid != null && numberRegex.test(tempResult.ledgerid) == false) {
                  holdErrors.push({'lineNumber': sheetid, 'message': 'LEDGERID must be number.!'})
                }
                if(tempResult.debitfromtype != null && !['servicecenter','coloader','courier','networkvendor','vendor', 'store', 'branchdebit', 'rsc'].includes(tempResult.debitfromtype.toLowerCase().trim())) {
                  holdErrors.push({'lineNumber': sheetid, 'message': 'Invalid debit from type, Please provide valid debitfromtype.!'});
                }
                if(tempResult.recoveredamt != null && floatNumber.test(tempResult.recoveredamt) == false) {
                  holdErrors.push({'lineNumber': sheetid, 'message': 'RECOVEREDAMT must be number.!'})
                }
                // if(tempResult.debitamount != null && floatNumber.test(tempResult.debitamount) == false) {
                //   holdErrors.push({'lineNumber': sheetid, 'message': 'TOTALDUEAMT must be number.!'})
                // }
                if(tempResult.recoveredamt != null && tempResult.recoveredamt <= 0) {
                  holdErrors.push({'lineNumber': sheetid, 'message': 'RECOVEREDAMT must be greater than zero.!'})
                }

                if (approvalFor1 == "hrclosedebit" || approvalFor1 == "financerecovery") {
                  if (tempResult.debitstatus.toLowerCase().trim() != "companydebit" && tempResult.debitstatus.toLowerCase().trim() != "recovered") {
                    console.log(approvalFor1, tempResult.debitstatus.toLowerCase().trim());
                    holdErrors.push({ 'lineNumber': sheetid, 'message': 'DEBITSTATUS must be companydebit/recovered' });
                  }
                }

                if(approvalFor1 == "financerecovery" && tempResult.debitnoteid != null && numberRegex.test(tempResult.debitnoteid) == false) {
                  holdErrors.push({'lineNumber': sheetid, 'message': 'DEBITNOTEID must be number.!'})
                }
                // const found1 = csvData.some(el => el.debitnoteid === tempResult.debitnoteid);
                // if(found1 && approvalFor1=="financerecovery"){
                //   holdErrors.push({'lineNumber': sheetid, 'message': 'Duplicate Debit ID not allowed .!'})
                // }

                if(approvalFor1 == "financerecovery" && tempResult.debitnotedate != null){
                  const date = moment(tempResult.debitnotedate, ['MM/DD/YYYY', 'YYYY-MM-DD', 'DD/MM/YYYY', 'YYYY/MM/DD']);
                  tempResult.debitnotedate=date.format('YYYY-MM-DD');
                }
                const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
                if(approvalFor1 == "financerecovery" && tempResult.debitnotedate != null && dateRegex.test(tempResult.debitnotedate) == false) {
                  holdErrors.push({'lineNumber': sheetid, 'message': 'DEBITNOTEDATE fromat must be "yyyy/mm/dd".!'})
                }
                if(approvalFor1=="financerecovery" && tempResult.debitnotedate!= null){
                  tempResult.debitnotedate=tempResult.debitnotedate+' '+'00:00:00.000';
                }
                // debitstatus
                if((approvalFor1=="hrclosedebit" || approvalFor1=="financerecovery")){
                  if(tempResult.debitstatus.toLowerCase().trim()==="companydebit"){
                    tempResult.debitstatus="companydebit";
                  }else if(tempResult.debitstatus.toLowerCase().trim()==="recovered"){
                    tempResult.debitstatus="recovered";
                  }
                }
                //debitFromType
                if(tempResult.debitfromtype.toLowerCase().trim()==="servicecenter"){
                  tempResult.debitfromtype="ServiceCenter"
                }else if(tempResult.debitfromtype.toLowerCase().trim()==="coloader"){
                  tempResult.debitfromtype="Coloader"
                }else if(tempResult.debitfromtype.toLowerCase().trim()==="courier"){
                  tempResult.debitfromtype="Courier"
                }else if(tempResult.debitfromtype.toLowerCase().trim()==="networkvendor"){
                  tempResult.debitfromtype="NetworkVendor"
                }else if(tempResult.debitfromtype.toLowerCase().trim()==="vendor"){
                  tempResult.debitfromtype="Vendor"
                }

                if(tempResult.debitid != null && tempResult.debitfromtype != null &&
                  tempResult.recoveredamt != null
                  || (approvalFor1=="financeclosed" && tempResult.ledgerid != null))
                  {
                    csvData.push(tempResult);
                    // console.log("CVSDATA_____________", csvData)
                  }

                console.log("csvData ----------->>", csvData);

            },
            complete: function(){
              console.log(" Completed");
              let lrpagelimit = this.UploadConfigDetails && this.UploadConfigDetails.pageCuttoff && this.UploadConfigDetails.pageCuttoff != '' ? Number(this.UploadConfigDetails.pageCuttoff) :   1001
              let lrBatchlimit = this.UploadConfigDetails && this.UploadConfigDetails.batchCuttoff && this.UploadConfigDetails.batchCuttoff != '' ?  Number(this.UploadConfigDetails.batchCuttoff) : 5000
              // let lrpagelimit = 100
              // let lrBatchlimit=100
              console.log('pagelimit ----->', lrpagelimit);
              console.log('Batchlimit ----->', lrBatchlimit);
              // console.log('validheader ----->', validheader);
              if(validheader == 0){
                this.isLoading1 = false;
                this.recoveryFiledata = [];
                this.recoveryfilename = null;
                this.recoveryfile = ''
                return this.$alertify.error('header mismatch issue, Please make ensure header should be in uppercase.!', "", "error");

              } else if(holdErrors.length > 0){
                this.errorList1 = holdErrors
                this.isLoading1 = false;
                this.recoveryFiledata = [];
                this.recoveryfilename = null;
                this.recoveryfile = ''
                return this.$alertify.error('Invalid data in the file.', "", "error");

              } else if(csvData.length<1){
                this.isLoading1 = false;
                this.recoveryFiledata = [];
                this.recoveryfilename = null;
                this.recoveryfile = ''
                return this.$alertify.error('Uploaded file is blank. At least one record set is required.', "", "error");
              } else if (csvData.length > lrpagelimit) {
                this.errorList1 = holdErrors
                this.isLoading1 = false;
                this.recoveryFiledata = [];
                this.recoveryfilename = null;
                this.recoveryfile = ''
                return this.$alertify.error(`Allowed only ${lrpagelimit} shipments in one go, please upload file accordingly.`, "", "error");
              }
              else{
                this.recoveryFiledata = csvData;
                this.totalrecords = csvData.length;
                console.log("this.recoveryFiledata ==============>>", this.recoveryFiledata);
                console.log("this.this.totalrecords ==============>>", this.totalrecords);
                this.chunkArray1(this.recoveryFiledata, lrBatchlimit); //pass batch cuttoff
              }
            }.bind(this)
        });
        // }
      },
      async chunkArray1(myArray, chunk_size){
            try {
            console.log("Start Time", Date() );
            // var index = 0;
            const sourceArray = JSON.parse(JSON.stringify(myArray));
            const arrayLength = sourceArray.length;
            let tempArr = [];
            let promiseArray = []
            this.UpdateApprovalKey1 = [];
            this.PromiseChainResult1 = [];
            let uniqueUploadID = this.generateUploadId(this.localuserid);

            let chain = Promise.resolve();
            let self = this;
            for (let index = 0; index < arrayLength; index += chunk_size) {
              const startIndex = index; // capture value
              // const myChunk = myArray.slice(startIndex, startIndex + chunk_size);
              const myChunk = sourceArray.slice(startIndex, startIndex + chunk_size);

              chain = chain.then(() =>
                self.uploadHRApproval1(myChunk, startIndex, uniqueUploadID)
              );
            }
            chain.then((result) => {
              // console.log('Result  Test---->>', result);
              if(result) {
                let tempTotalCount = 0;
                let tempUploadedTotalCount = 0;
                this.PromiseChainResult1.forEach((value,idx) => {
                  tempTotalCount = parseFloat(tempTotalCount) + parseFloat(value.TotalCount)
                  tempUploadedTotalCount = parseFloat(tempUploadedTotalCount) + parseFloat(value.insertedCount)
                })
                this.recoveryuploadResult = [];
                this.recoveryuploadResult.push({"totalCount": tempTotalCount, "uploadeCount": tempUploadedTotalCount});
                // this.$alertify.success("File data loaded Successfully");
                let reqObjectProcess = {
                  batchkey: this.UpdateApprovalKey1,
                  statusfor: this.approvalfor1,
                  lastmodifiedby: this.localusermailid
                }
                console.log("End Time", Date());
                this.triggerPopUpDialogForConfirmation1(this.recoveryuploadResult, reqObjectProcess)
              } else {
                 this.isLoading1 = false;
                 return false;
               }
               this.isLoading1 = false;
            })
            .catch((err) => {
              console.log('chain error', err);
            })
          }catch (err){
            console.log(err);
          }
       },
       async triggerPopUpDialogForConfirmation1(getResult, reqObjectProcess) {
        console.log("triggerPopUpDialogForConfirmation1")
         let htmltablecontent = '<table border="2" cellpadding="10" cellspacing="0"> <th>Total Count</th> <th>Uploaded Count</th>';
         let resultcount = getResult.length
         for(let j=0; j< resultcount; j++) {

           htmltablecontent +=`
             <tr>
               <td> ${getResult[j].totalCount} </td>
               <td> ${getResult[j].uploadeCount } </td>
             </tr>`
         }
         htmltablecontent += `</table>`;
         // console.log('htmltablecontent --->>', htmltablecontent);
         let message = {
             title: 'Alert',
             body: `<p>Uploaded summary.! <br/> Do you want to proceed for update approval? </p><br/>
             ${htmltablecontent}
             <br>
             `,
           };

           let res = await this.$dialog.confirm(message, {
             html: true,
             animation: 'bounce',
             backdropClose: false,
             okText: 'Yes',
             cancelText: 'No',
             reverse: true
           })
           .then(dialog => {
             console.log('success', reqObjectProcess);
             this.$alertify.success("File uploaded successfully, Proccess will be done at mid night & output summary will be send over email.");
            //  this.processDumpData1(reqObjectProcess)
            this.clear1();
           })
           .catch((e) => {
             //add logic for delete mechanism.
             console.log('popup catch',e);
           })
       },
       // processDumpData1(reqObjectProcess) {
       //  const Url = apiUrl.api_url + 'raiseDebit/updatededuction/processUploaded/dump';
       //   axios({
       //     method: 'POST',
       //      url: Url,
       //      data: reqObjectProcess
       //   }).then(async approveHRresult => {
       //     console.log('approveHRresult -->>', approveHRresult);
       //     this.clear()
       //   }, error => {
       //     this.ConfirmLoader = false
       //   });
       // },

       uploadHRApproval1(myChunk, index, uploaduniqueid) {
        return new Promise((resolve, reject) => {
          try {
            let batchId =`F${(Math.random() + 1).toString(36).substring(9)}`;
            console.log("random", batchId);
            let newChunkArray = myChunk.map(chunk => Object.assign(chunk, {approvalkey: batchId, upload_id: uploaduniqueid}))
            this.UpdateApprovalKey1.push(batchId)
            console.log("=======<<<<<<<<", this.localusermailid, this.recoveryfilename)
            let approveObj = {
              approvalShipments: newChunkArray,
              approvalKey: batchId,
              approvalFor: this.approvalfor1,
              CreatedBy: this.localusermailid,
              filename: this.recoveryfilename,
              upload_id: uploaduniqueid
            }
            axios({
              method: 'POST',
              url: apiUrl.api_url + 'raiseDebit/updatededuction/upload/dump',
              data: approveObj
            }).then(async approveHRresult => {
              this.batchkeyArray1.push(batchId)
              if (approveHRresult.data.code == 200) {
                this.PromiseChainResult1.push(approveHRresult.data.data)
                resolve(true)
              }else if (approveHRresult.data.code == 202){
                this.$alertify.error('Invalid data in csv file, '+ approveHRresult.data.message);
                resolve(false)
              } else {
                this.$alertify.error(approveHRresult.data.message);
                resolve(true)
              }

            }, error => {
              resolve(false)
              console.error(1,error)
              this.ConfirmLoader = false
            });
          } catch(e) {
            resolve(e)
          }
        })
      },
      getconfigFlags() {
        return new Promise((resolve,reject) => {
          axios({
            method: 'POST',
            url: apiUrl.api_url + 'rediscluster/get',
            data: { "key": "uploadConfigskeysFlag" }
          }).then(async getconfigset => {
            console.log('getconfigset -->', getconfigset);
            resolve(getconfigset.data.message)
          })
        })
      },
    validateForm(scope) {
      this.$validator.validateAll(scope).then(async result => {
        if (result) {
          // Upload started.!
          await this.parseFile1();
        } else {
          console.log("result =======>>", result);
          this.$alertify.error('Please select mandatory fields.!');
        }
      }).catch((e) => {
        console.log('log errors', e);
      });
    },
    clear(){
     this.UpdateApprovalKey = [];
      this.PromiseChainResult = [];
      this.isLoading = false;
      this.filedata = [];
      this.filename = null;
      this.file = ''
      this.uploadApprovecsv = ''
      this.approvalfor = '0'
      this.errorList = []
      const input = this.$refs.files;
      input.type = 'text';
      input.type = 'file';
      console.log('file cleared.!');
      this.$validator.reset();
      this.errors.clear();
    },

    clear1(){
      this.UpdateApprovalKey1 = [];
      this.PromiseChainResult1 = [];
      this.isLoading1 = false;
      this.recoveryFiledata = [];
      this.recoveryfilename = null;
      this.recoveryfile = ''
      this.uploadApprovecsv1 = ''
      this.approvalfor1 = '0'
      this.errorList1 = []
      const input = this.$refs.files;
      input.type = 'text';
      input.type = 'file';

      console.log('file cleared.!');
      this.$validator.reset();
      this.errors.clear();
    },
    downloadsampleformat() {
      let sampleData = [
        {
          "SHIPPINGID": "1234567898",
          "DEBITFROMTYPE": "servicecenter",
          "DEBITID": "12345",
        },
      ];
      let csvContent = "data:text/csv;charset=utf-8,";
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      let filename = "uploadSamleFormat" + today + ".csv";
      csvContent += [
        Object.keys(sampleData[0]).join(";"),
        ...sampleData.map(item => Object.values(item).join(";"))
      ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },

    downloadsampleformat1(fileType) {
      let sampleDataHR = [
        {
          "EMPLOYEECODE": "123456789",
          "RECOVEREDAMT": "2000",
          "DEBITSTATUS":"recovered",
          "REMARKS": "Recovery done against salary"
        },
        {
          "EMPLOYEECODE": "12345678",
          "RECOVEREDAMT": "2000",
          "DEBITSTATUS":"companydebit",
          "REMARKS": "Recovery done against fuel"
        },
      ];
      let sampleDataFinancerecovery = [
        {
          "XBPARTNERID": "123456789",
          "DEBITFROMTYPE": "coloader",
          "RECOVEREDAMT": "2000",
          "DEBITSTATUS":"recovered",
          "DEBITNOTEID": "67647",
          "DEBITNOTEDATE":"2023/05/25",
          "RECOVERYLEDGERNAME": "ABC",
          "NOTES": "COLUMN A : Input Coloader ID || COLUMN B : DebitFromtype as coloader || COLUMN C : Recovered amount || COLUMN D : Debit status - 'recovery' value means actual recovery || COLUMN E to G : Debit note id and Note Date and Ledgername of finance accounts."
        },
        {
          "XBPARTNERID": "123456789",
          "DEBITFROMTYPE": "coloader",
          "RECOVEREDAMT": "2000",
          "DEBITSTATUS":"companydebit",
          "DEBITNOTEID": "67647",
          "DEBITNOTEDATE":"2023/05/25",
          "RECOVERYLEDGERNAME": "ABC",
          "NOTES": "COLUMN A : Input Coloader ID || COLUMN B : DebitFromtype as coloader || COLUMN C : Recovered amount || COLUMN D : Debit status - 'companydebit' value means self debit || COLUMN E to G : Debit note id and Note Date and Ledgername of finance accounts."
        },
        {
          "XBPARTNERID": "123456789",
          "DEBITFROMTYPE": "courier",
          "RECOVEREDAMT": "2000",
          "DEBITSTATUS":"recovered",
          "DEBITNOTEID": "12334",
          "DEBITNOTEDATE":"2023/05/25",
          "RECOVERYLEDGERNAME": "ABC",
          "NOTES": "COLUMN A : Input courier ID || COLUMN B : DebitFromtype as courier || COLUMN C : Recovered amount || COLUMN D : Debit status - 'recovery' value means actual recovery || COLUMN E to G : Debit note id and Note Date and Ledgername of finance accounts."
        },
        {
          "XBPARTNERID": "123456789",
          "DEBITFROMTYPE": "networkvendor",
          "RECOVEREDAMT": "2000",
          "DEBITSTATUS":"recovered",
          "DEBITNOTEID": "12345",
          "DEBITNOTEDATE":"2023/05/25",
          "RECOVERYLEDGERNAME": "ABC",
          "NOTES": "COLUMN A : Input networkvendor ID || COLUMN B : DebitFromtype as networkvendor || COLUMN C : Recovered amount || COLUMN D : Debit status - 'recovery' value means actual recovery || COLUMN E to G : Debit note id and Note Date and Ledgername of finance accounts."
        },
        {
          "XBPARTNERID": "123456789",
          "DEBITFROMTYPE": "store",
          "RECOVEREDAMT": "2000",
          "DEBITSTATUS":"recovered",
          "DEBITNOTEID": "67647",
          "DEBITNOTEDATE":"2023/05/25",
          "RECOVERYLEDGERNAME": "ABC",
          "NOTES": "COLUMN A : Input store ID || COLUMN B : DebitFromtype as store || COLUMN C : Recovered amount || COLUMN D : Debit status - 'recovery' value means actual recovery || COLUMN E to G : Debit note id and Note Date and Ledgername of finance accounts."
        },
        {
          "XBPARTNERID": "123456789",
          "DEBITFROMTYPE": "rsc",
          "RECOVEREDAMT": "2000",
          "DEBITSTATUS":"recovered",
          "DEBITNOTEID": "67647",
          "DEBITNOTEDATE":"2023/05/25",
          "RECOVERYLEDGERNAME": "ABC",
          "NOTES": "COLUMN A : Input rsc ID || COLUMN B : DebitFromtype as rsc || COLUMN C : Recovered amount || COLUMN D : Debit status - 'recovery' value means actual recovery || COLUMN E to G : Debit note id and Note Date and Ledgername of finance accounts."
        },
      ];
      let sampleDataFinance = [
        {
          "EMPLOYEECODE": "123456789",
          "RECOVEREDAMT": "2000",
          "LEDGERID":"13344",
        },
      ];
      let sampleData='';
      if(fileType==="HR"){
         sampleData=sampleDataHR
      }else if(fileType==="financerecovery"){
         sampleData=sampleDataFinancerecovery
      }else{
         sampleData=sampleDataFinance;
      }
      let csvContent = "data:text/csv;charset=utf-8,";
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + "" + mm + "" + yyyy;
      let filename = "uploadSamleFormat"+fileType+ + today + ".csv";
      csvContent += [
        Object.keys(sampleData[0]).join(","),
        ...sampleData.map(item => Object.values(item).join(","))
      ]
      .join("\n")
      .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", filename);
      link.click();
    },

    setApprovalFor(e){
      this.approvalfor1=e.target.value;
    }
  },
}



// WEBPACK FOOTER //
// ./src/views/components/LOST/lostUploadApproval/lostUploadApproval.component.js